import { freshFeed, type FeedItem } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-600',
};

function FeedCard({ item }: { item: FeedItem }) {
  const bar = toneMap[item.tagTone] ?? toneMap.secondary;
  return (
    <article className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
      <a href="#crowd" className="relative block h-44 w-full overflow-hidden">
        <img
          src={item.img}
          alt={item.imgAlt}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent"></div>
        {item.hot && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-bold text-primary-950">
            <i className="ri-fire-fill" aria-hidden="true"></i>热议
          </span>
        )}
        <span
          className={`absolute bottom-3 left-3 rounded-full px-2.5 py-0.5 text-xs font-semibold text-background-50 ${bar}`}
        >
          {item.tag}
        </span>
      </a>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="text-base md:text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          <a href="#crowd">{item.title}</a>
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{item.summary}</p>
        <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-700">
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true"></i>{item.reads} 围观
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-3-line" aria-hidden="true"></i>{item.comments} 讨论
          </span>
          <a
            href="#submit"
            className="ml-auto inline-flex items-center gap-1 font-medium text-primary-600 hover:text-primary-700"
          >
            去评论 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </article>
  );
}

export default function FreshFeed() {
  return (
    <section id="fresh" className="mx-auto w-full max-w-6xl scroll-mt-24 px-4 md:px-8 py-16 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <SectionHeading
          align="left"
          eyebrow="最新鲜瓜"
          title="今天该刷点什么"
          accentWord="就看这里"
          desc="编辑团队持续整理的最新瓜圈资讯，分类清晰、来源标注，配着瓜子看刚刚好。"
        />
        <div className="flex gap-2">
          <button
            type="button"
            className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-md bg-primary-50 px-3 py-2 text-xs font-semibold text-primary-600 hover:bg-primary-100"
          >
            <i className="ri-fire-line" aria-hidden="true"></i>按热度
          </button>
          <button
            type="button"
            className="whitespace-nowrap inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-2 text-xs font-semibold text-secondary-900 hover:bg-secondary-200"
          >
            <i className="ri-time-line" aria-hidden="true"></i>按最新
          </button>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {freshFeed.map((item) => (
          <FeedCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}